export const increaseLimitsPlans = [
  {
    planType: 0,
    img: 'boring',
    name: 'Tester',
    requirements: ['requirements_none'],
    values: {
      count_free_card: 1,
      monthly_card_spent_limit: 30,
      top_up_channels: 'USDC, BTC, ETH',
    },
    features: ['create_free_card', 'max_credit_limit', 'top_up_channels'],
  },

  {
    planType: 1,
    img: 'peacock',
    name: 'Starter',
    requirements: ['verification', 'monthly_volume_range'],
    values: {
      count_free_card: 30,
      daily_card_limit: '500',
      monthly_card_spent_limit: '300,000',
      top_up_commission: 3.5,
      withdraw_commission: 2,
      top_up_channels: 'USDC, USDT, ETH, BTC, LTC',
      volume_from: '0',
      volume_to: '300,000',
    },
    features: [
      'free_cards_up_to',
      'cards_daily',
      'max_credit_limit',
      'top_up_fee_commission',
      'withdraw_fee',
      'top_up_channels',
    ],
  },

  {
    planType: 2,
    img: 'star',
    name: 'Premium',
    requirements: ['verification', 'monthly_volume_range'],
    values: {
      count_free_card: 30,
      daily_card_limit: '1,500',
      monthly_card_spent_limit: '300,000',
      top_up_commission: 2.5,
      withdraw_commission: 2,
      top_up_channels: 'USDC, USDT, ETH, BTC, LTC + Wire',
      volume_from: '300,000',
      volume_to: '600,000',
    },
    features: [
      'free_cards_up_to',
      'cards_daily',
      'max_credit_limit',
      'top_up_fee_commission',
      'withdraw_fee',
      'top_up_channels',
    ],
  },

  {
    planType: 3,
    img: 'crown',
    name: 'Private client',
    requirements: ['verification', 'monthly_volume_range'],
    values: {
      count_free_card: 30,
      daily_card_limit: 'unlimited',
      monthly_card_spent_limit: '300,000',
      top_up_commission: 1.8,
      withdraw_commission: 1,
      top_up_channels: 'USDC, USDT, ETH, BTC, LTC + Wire',
      volume_from: '600,000',
      volume_to: '1,000,000',
    },
    features: [
      'free_cards_up_to',
      'cards_daily',
      'max_credit_limit',
      'top_up_fee_commission',
      'withdraw_fee',
      'top_up_channels',
    ],
  },
];
